import { RobotVacuumAlertIcon } from './RobotVacuumAlertIcon';

/**
 * author: Michael Irigoyen
 * id 05DDCBE1-561A-4961-87F7-CA9BE0C182BE
 * name robot-vacuum-alert
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-vacuum-alert.svg
 * tags
 * - Alert / Error 
 * - Home Automation 
 */
export const RobotVacuumErrorIcon = RobotVacuumAlertIcon;
export default RobotVacuumErrorIcon